// Central API configuration.
// In dev the backends run on localhost:8081 / localhost:5050.
// In production nginx (same origin) proxies /api/(puzzle|stats|analysis)
// to port 5050 and all other /api/ paths to port 8081.
const isDev = window.location.port === '8080';

const host = window.location.hostname;

export const AUTH_BASE = isDev ? `http://${host}:8081` : '';
export const CHESS_BASE = isDev ? `http://${host}:5050` : '';

export const AUTH_API = `${AUTH_BASE}/api/auth`;
export const GAME_API = `${AUTH_BASE}/api/game`;
export const ARENA_API = `${AUTH_BASE}/api/arena`;
export const LEADERBOARD_API = `${AUTH_BASE}/api/leaderboard`;
export const MULTIPLAYER_API = `${AUTH_BASE}/api`;
export const PUZZLE_API = `${CHESS_BASE}/api`;

export function authHeaders() {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}
